import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";

import { colors, IconButton, Snackbar, TextField } from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { insh, sto } from "../../../../Context/InshData";
import Print from "@material-ui/icons/Print";

import { useStylesLbl, useStylesSN } from "../../../../St/comps/UseStyle";
import { Toaster } from "react-hot-toast";
import { Alert } from "@material-ui/lab";
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650,
        minHeight:500,
    },
}));

export default function SnackBarAlert(props) {
    const { isSnak, textAlert} = props;

    const [snack, setSnack] = React.useState(insh.Snack);

    // const classes = useStyles();
    const styBtn = {
        dis: { color: "#3b773d", background: "#4fa152" },
        undis: { color: "#fff" },
      };
    const clasSN = useStylesSN();
    const handOSnack = () => {
        setSnack({ openSnak: isSnak, 
             vertical: "top",
            horizontal: "center",
            severit: "warning",
            text: textAlert,
            time: 2000, });
      };
    
      const handCSnack = (event, reason) => {
        // if (reason === 'clickaway') { return; }
        setSnack({ ...snack, openSnak: false });
      };
      const { vertical, horizontal, openSnak } = snack;
      useEffect(() => {
        // console.log("the rowssss is", props.invData)
    
        handOSnack();
      }, []);
    
    return (
        <div className={clasSN.rootSN}>
          <Toaster />
  
          <Snackbar
            anchorOrigin={{ vertical, horizontal }}
            open={openSnak}
            autoHideDuration={snack.time}
            onClose={handCSnack}
            key={vertical + horizontal}
            className={clasSN.snackbarSN}
          >
            <Alert onClose={handCSnack} severity={snack.severit}>
              {" "}
              {snack.text}{" "}
            </Alert>
          </Snackbar>
        </div>
      );
}
